module.exports = __webpack_public_path__ + "media/formation-finished.2e8e2dd6.mp3";